/** Eenmalige 🔥-pulse bij streak 2; schrijft streakTwo na animatie (of direct bij reduced motion). */
import { useCallback, useEffect, useRef, useState } from 'react';
import { ONBOARDING_HINT_STREAK_TWO } from '@/constants/onboardingHints';
import { useAuth } from '@/features/auth/useAuth';
import { useTier } from '@/features/tier/useTier';
import { markHintSeen } from '@/services/userService';

const STREAK_TWO = 2;

/**
 * @param {number} streak
 * @returns {{ pulseActive: boolean, onPulseEnd: () => void }}
 */
export function useStreakTwoPulse(streak) {
  const { user } = useAuth();
  const { seenHints, profileLoaded } = useTier();
  const markedRef = useRef(false);
  const [pulseActive, setPulseActive] = useState(false);

  const hintSeen = seenHints.includes(ONBOARDING_HINT_STREAK_TWO);
  const eligible =
    streak === STREAK_TWO && profileLoaded && Boolean(user?.uid) && !hintSeen;

  useEffect(() => {
    if (!eligible || markedRef.current) {
      return;
    }

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches;
    if (reducedMotion) {
      markedRef.current = true;
      void markHintSeen(user.uid, ONBOARDING_HINT_STREAK_TWO);
      return;
    }

    setPulseActive(true);
  }, [eligible, user?.uid]);

  const onPulseEnd = useCallback(() => {
    if (!user?.uid || markedRef.current) {
      return;
    }
    markedRef.current = true;
    setPulseActive(false);
    void markHintSeen(user.uid, ONBOARDING_HINT_STREAK_TWO);
  }, [user?.uid]);

  return { pulseActive, onPulseEnd };
}
